import Twitter from "@/components/icons/Twitter"
import { SocialMediaLinks } from "@types"
import { Rss } from "lucide-react"
import { FaFacebook, FaGithub, FaInstagram } from "react-icons/fa"
import { cn } from "@/lib/utils"
import FarcasterIconClient from "./FarcasterIconClient"
import { cleanFacebookUrl } from "@/lib/social-utils"

/**
 * To make this component useable from client components, we skip the RSC-only Farcaster user fetch that the SocialLinks component performs.
 * Instead, if you know the farcaster username, just pass it in as normal.
 */
export default function SocialLinksClient({
  className,
  socials,
  blogUrl,
  fcUsername,
}: {
  className?: string
  socials?: SocialMediaLinks
  blogUrl?: string
  fcUsername?: string
}) {
  if (
    !fcUsername &&
    !socials?.facebook &&
    !socials?.farcaster &&
    !socials?.github &&
    !socials?.instagram &&
    !socials?.twitter
  ) {
    return null
  }

  return (
    <div
      className={cn(
        "flex flex-row gap-4 text-muted-foreground pb-2",
        className
      )}
    >
      {/* If we already have the farcaster username, just use the client component to display it. This lets us use SocialLinks in client components. */}
      {fcUsername && <FarcasterIconClient fcUsername={fcUsername} />}

      {socials?.twitter && (
        <a
          href={`https://x.com/${socials?.twitter}`}
          target="_blank"
          rel="noreferrer"
        >
          <Twitter className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {socials?.instagram && (
        <a
          href={`https://instagram.com/${socials?.instagram}`}
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {socials?.github && (
        <a
          href={`https://github.com/${socials?.github}`}
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {socials?.facebook && (
        <a
          href={cleanFacebookUrl(socials.facebook)}
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebook className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {blogUrl && (
        <a
          href={`https://paragraph.com/api/blogs/rss/${blogUrl}`}
          target="_blank"
          rel="noreferrer"
        >
          <Rss className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
    </div>
  )
}
